var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ipad-prompt"
  }, [_c('h2', [_vm._v("Tap the option that matches what you have")]), _c('div', {
    staticClass: "keyboard-choice-wrapper"
  }, [_c('div', [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.chooseExternalKeyboard(false);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.iPadHands
    }
  })]), _c('span', [_vm._v("Just the iPad")])]), _c('div', [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.chooseExternalKeyboard(true);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.keyboardHands
    }
  })]), _c('span', [_vm._v("Separate keyboard and iPad")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }